import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { BeatLoader } from 'react-spinners';
import { bindActionCreators } from 'redux';
import { utilService } from '../../../common/utils';
import * as adminActions from '../../../store/admin';
import * as pagesActions from '../../../store/portal';
import { filterTasks } from '../helper/pagesHelper';

// prev, current, next year
const yearTrio = [
  { year: moment().subtract(1, 'year').year() },
  { year: moment().year(), default: true },
  { year: moment().add(1, 'year').year() },
];

function AssessmentTasks(props) {
  const { tasks, getCourseTasks, token, taskActionLoading, placeID } = props;
  const filteredTasks = filterTasks(tasks);
  function handleTaskYearChange(e) {
    const year = e.target.value;
    //get course tasks by course ID and year
    getCourseTasks({
      token: token,
      params: '?course_id=' + placeID + '&selected_year=' + year,
    });
  }

  React.useEffect(() => {
    const defaultYear = yearTrio.find((year) => year.default).year;
    getCourseTasks({
      token: token,
      params: '?course_id=' + placeID + '&selected_year=' + defaultYear,
    });
  }, []);

  return (
    <>
      <div className="d-flex align-items-center mb-5">
        <label htmlFor="selected_year" className="mr-3 text-nowrap">
          Select Year
        </label>
        <select
          name="selected_year"
          id="selected_year"
          className="form-control flex-grow-1"
          onChange={handleTaskYearChange}
          defaultValue={yearTrio.find((year) => year.default).year}
        >
          {yearTrio.map((year) => (
            <option key={year.year} value={year.year}>
              {year.year}
            </option>
          ))}
        </select>
      </div>
      <div className="table-responsive">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th className="text-nowrap">Task Name</th>
              <th className="text-nowrap">Weighting</th>
              <th className="text-nowrap">Mark Out Of</th>
              <th className="text-nowrap">Set Date</th>
              <th className="text-nowrap">Due Date</th>
              <th className="text-nowrap">Released</th>
            </tr>
          </thead>
          <tbody>
            {taskActionLoading && (
              <tr>
                <td colSpan={6} className="text-center pb-2">
                  <BeatLoader
                    loading={taskActionLoading}
                    margin="5px"
                    size={15}
                    color={utilService.loaderColor}
                  />
                </td>
              </tr>
            )}
            {!taskActionLoading &&
              (filteredTasks.length ? (
                filteredTasks.map((task, index) => (
                  <tr key={'task' + index}>
                    <td className="text-nowrap">{task.TASK}</td>
                    <td className="text-nowrap">
                      {parseFloat(task.WEIGHTING)}%
                    </td>
                    <td className="text-nowrap">
                      {parseInt(task.MARK_OUT_OF)}
                    </td>
                    <td className="text-nowrap">
                      {moment(task.SET_DATE).format('ddd MMM D, Y')}
                    </td>
                    <td className="text-nowrap">
                      {moment(task.DUE_DATE).format('ddd MMM D, Y')}
                    </td>
                    <td>
                      {task.LEARNING_RESOURCES && task.LEARNING_RESOURCES.length
                        ? task.LEARNING_RESOURCES.map((res) =>
                            res.LEARNING_RESOURCE !== null &&
                            res.LEARNING_RESOURCE_URL !== null ? (
                              <div key={'resource' + task.TASK + index}>
                                <a
                                  href={res.LEARNING_RESOURCE_URL}
                                  className="text-primary"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {res.LEARNING_RESOURCE}
                                </a>
                              </div>
                            ) : (
                              '-'
                            )
                          )
                        : '-'}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    Select another year
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

AssessmentTasks.propTypes = {
  placeID: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  console.log('state', state);
  return {
    taskActionLoading: state.courseTasks.actionsloading,
    token: state.user.cognito_data.token,
    tasks: Object.values(state.courseTasks.byId),
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, pagesActions, adminActions), dispatch)
)(AssessmentTasks);
